import { render, staticRenderFns } from "./Checkouts.vue?vue&type=template&id=f4de5c70&scoped=true&"
import script from "./Checkouts.vue?vue&type=script&lang=js&"
export * from "./Checkouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4de5c70",
  null
  
)

export default component.exports